import {trl} from '~/services/intl'
import {useCurrentUser} from '~/services/user'
import {formatSize} from '~/utils/formatSize'

export default function() {
    const [currentUser] = useCurrentUser()

    if (!currentUser)
        return null

    return (
        <div className='usage-metric'>
            <span className='usage-metric__title'>
                {trl('Хранилище')}
            </span>
            <meter
                className='usage-metric__indicator'
                value={currentUser.usage.storage_capacity}
                low={0.95 * currentUser.limits.storage_capacity}
                high={0.95 * currentUser.limits.storage_capacity}
                max={currentUser.limits.storage_capacity}
            />
            <div
                className='usage-metric__info'
                dangerouslySetInnerHTML={{__html: trl(
                    'Использовано %0 из %1.html',
                    formatSize(currentUser.usage.storage_capacity),
                    formatSize(currentUser.limits.storage_capacity),
                )}}
            />
        </div>
    )
}
